import { Commit, Module } from 'vuex';
import ChatService from '~/services/ChatService';
import { User } from 'talkjs/all';

interface TalkSessionState {
    unreadMessagesCount: number | null;
    chatService: ChatService | null;
    myTalkJsUser: User | null;
    currentConversationId: string | null;
}

const talkStore: Module<TalkSessionState, TalkSessionState> = {
    state: {
        unreadMessagesCount: null,
        chatService: null,
        myTalkJsUser: null,
        currentConversationId: null,
    },
    getters: {
        getUnreadMessagesCount: (state: TalkSessionState) => () => state.unreadMessagesCount,
        getMyTalkJsUser: (state: TalkSessionState) => () => state.myTalkJsUser,
        getChatService: (state: TalkSessionState) => () => state.chatService,
        getCurrentConversationId: (state: TalkSessionState) => () => state.currentConversationId,
    },
    mutations: {
        setUnreadMessagesCount(state: TalkSessionState, unreadMessagesCount: number | null) {
            state.unreadMessagesCount = unreadMessagesCount;
        },
        setChatService(state: TalkSessionState, chatService: ChatService) {
            if (state.chatService != null) {
                console.warn('[Store]: re-initializing chatService');
            }
            state.chatService = chatService;
        },
        setMyTalkJsUser(state: TalkSessionState, myTalkJsUser: User | null) {
            state.myTalkJsUser = myTalkJsUser;
        },
        setCurrentConversationId(state: TalkSessionState, currentConversationId: string | null) {
            state.currentConversationId = currentConversationId;
        },
    },
    actions: {
        updateUnreadMessagesCount(
            { commit }: { commit: Commit },
            unreadMessagesCount: number | null
        ) {
            commit('setUnreadMessagesCount', unreadMessagesCount);
        },
        updateMyTalkJsUser({ commit }: { commit: Commit }, myTalkJsUser: number | null) {
            commit('setMyTalkJsUser', myTalkJsUser);
        },
        updateChatService({ commit }: { commit: Commit }, chatService: ChatService | null) {
            commit('setChatService', chatService);
        },
        updateCurrentConversationId(
            { commit }: { commit: Commit },
            currentConversationId: string | null
        ) {
            commit('setCurrentConversationId', currentConversationId);
        },
    },
};

export default talkStore;
